export enum CareTeamRoleCode {
  intern = 'careteam.general.intern',
  nurse = 'careteam.quromedical.nurse',
  student = 'careteam.general.student',
  doctor = 'careteam.quromedical.doctor',
  registrar = 'careteam.general.registrars',
  consultant = 'careteam.general.consultant',
  medicalOfficer = 'careteam.general.medicalOfficer',
  clinicalAssociate = 'careteam.quromedical.clinicalAssociate',
  leadClinicalAssociate = 'careteam.quromedical.leadClinicalAssociate',
  communityServiceMedicalOfficer = 'careteam.general.communityServiceMedicalOfficer',
}

export const CareTeamRoleDescription: Record<CareTeamRoleCode, string> = {
  [CareTeamRoleCode.nurse]: 'Nurse',
  [CareTeamRoleCode.doctor]: 'Doctor',
  [CareTeamRoleCode.intern]: 'Intern',
  [CareTeamRoleCode.student]: 'Student',
  [CareTeamRoleCode.registrar]: 'Registrars',
  [CareTeamRoleCode.consultant]: 'Consultant',
  [CareTeamRoleCode.medicalOfficer]: 'Medical Officer',
  [CareTeamRoleCode.clinicalAssociate]: 'Clinical Associate',
  [CareTeamRoleCode.leadClinicalAssociate]: 'Lead Clinical Associate',
  [CareTeamRoleCode.communityServiceMedicalOfficer]:
    'Community Service Medical Officer',
};

export enum CareTeamTypeCode {
  careCoordinationTeam = 'careteam.general.careCoordinationTeam',
  careTeam = 'careteam.general.careTeam',
}

export const CareTeamTypeDescription: Record<CareTeamTypeCode, string> = {
  [CareTeamTypeCode.careCoordinationTeam]: 'Care Coordination Team',
  [CareTeamTypeCode.careTeam]: 'Care Team',
};
